export default __webpack_public_path__ + "static/media/CVVincentLEJEUNE.90c31dd0.pdf";